/* eslint-disable */
import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import { myConfig } from "./consts.mjs";
import { jwtDecode } from "jwt-decode";
import { useUserStore } from "./stores";
import router from "./routes";
const cognitoAuthConfig = {
    authority: myConfig.cognitoAuthority,
    client_id: myConfig.cognitoPoolClientID,
    redirect_uri: myConfig.cognitoRedirect,
    response_type: myConfig.cognitoResponseType,
    scope: myConfig.cognitoScope,
    storage: new WebStorageStateStore({ store: window.localStorage })
};
// console.log("redirect:", myConfig.cognitoRedirect);
// create a UserManager instance
export const userManager = new UserManager({
    ...cognitoAuthConfig,
});
export async function signOutRedirect() {
    const clientId = myConfig.cognitoPoolClientID;
    const logoutUri = myConfig.cognitoLogout;
    const cognitoDomain = myConfig.cognitoDomain;
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
}
export let authenticatedUser = null;
export const isUserInGroup = ((token, grp) => {
    if (token) {
        // console.info("Token during group check:", token)
        if (typeof token === "string") {
            const inGrp = jwtDecode(token);
            const cogs = inGrp["cognito:groups"];
            // console.log(cogs);
            if (cogs) {
                const chk = cogs.includes(grp);
                return chk;
            }
            return false;
        }
    }
    else {
        return false;
    }
});
export async function signInRedirect() {
    await userManager.signinRedirect();
}
// Handle the callback after authentication
export const processSignInResponse = async () => {
    try {
        authenticatedUser = await userManager.signinRedirectCallback();
        // console.log('User signed in:', authenticatedUser);
        const userStore = useUserStore();
        userStore.user = { name: '', app: false, auth: authenticatedUser, sub: null, at: authenticatedUser.access_token, ut: authenticatedUser.id_token, rt: authenticatedUser.refresh_token };
        if (typeof authenticatedUser.id_token === "string") {
            const toke = jwtDecode(authenticatedUser.id_token);
            userStore.user = { ...userStore.user, app: isUserInGroup(authenticatedUser.id_token, "ApprovedUsers"), sub: toke.sub };
        }
        router.push({ path: '/songde/reginfo' });
    }
    catch (error) {
        // console.error('Error signing in:', error);
        return false;
    }
};
export default userManager;
